import { render, staticRenderFns } from "./BarcodeItem.vue?vue&type=template&id=eb5209de"
import script from "./BarcodeItem.vue?vue&type=script&lang=js"
export * from "./BarcodeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports